var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6999_15218)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6999_15218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.14244 7.14239H17.8567M2.14244 7.14239V17.1424C2.14244 17.5212 2.29295 17.8847 2.56085 18.1525C2.82877 18.4204 3.19212 18.571 3.57101 18.571H16.4282C16.807 18.571 17.1704 18.4204 17.4383 18.1525C17.7062 17.8847 17.8567 17.5212 17.8567 17.1424V7.14239M2.14244 7.14239C1.35346 7.14239 0.713867 6.50279 0.713867 5.71381V2.85667C0.713867 2.0677 1.35346 1.4281 2.14244 1.4281H17.8567C18.6457 1.4281 19.2853 2.0677 19.2853 2.85667V5.71381C19.2853 6.50279 18.6457 7.14239 17.8567 7.14239M7.85672 11.4281H12.1424",
    stroke: "#A072EB",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6999_15218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6999_15218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.3406bbd673800a3b975296bd0510b9c2.svg";
export { ForwardRef as ReactComponent };